document.addEventListener('DOMContentLoaded', function () {
  const leftSide = document.querySelector('.hm-welcome-left');
  const rightSide = document.querySelector('.hm-welcome-right');

  if (leftSide) {
    leftSide.style.transform = 'translateX(-50px)'; /* aur kam kiya */
    leftSide.style.opacity = '0';
    leftSide.style.transition = 'transform 0.9s ease, opacity 0.9s ease';
  }

  if (rightSide) {
    rightSide.style.transform = 'translateX(50px)'; /* aur kam kiya */
    rightSide.style.opacity = '0';
    rightSide.style.transition = 'transform 0.9s ease, opacity 0.9s ease';
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.transform = 'translate(0, 0)';
        entry.target.style.opacity = '1';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  if (leftSide) observer.observe(leftSide);
  if (rightSide) observer.observe(rightSide);
});
